import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { authService } from '@S';

const checkRouteAccess = (path) => {
  const disabledRoutes = authService?.disabledRoutes;
  if (disabledRoutes?.includes(path)) {
    return true;
  }
  return false;
};

export { checkRouteAccess };
